import { CSSResultArray } from 'lit';
import host from '@maersk-global/mds-components-utils/host/host.styles.js';
import style from './mc-multi-choice-fieldset.scss';
import tokens from '@maersk-global/mds-design-tokens/implementation/core/multi-choice-fieldset/js/design-tokens-px.css.js';
export const styles: CSSResultArray = [host, tokens, style];
